export default "__VITE_ASSET__DYRuseBJ__"